import { Box, Container, Stack } from "@mui/material"
import React from "react"
import Categories from "../components/Categories"
import RecentPosts from "../components/RecentPosts"
import RightBar from "../components/RightBar"

const HomePage = () => {
  return (
    <Box>
      <Container>
        <Categories />
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          marginTop={8}
        >
          <Box flex={2}>
            <RecentPosts />
          </Box>
          <Box flex={1}>
            <RightBar />
          </Box>
        </Stack>
      </Container>
    </Box>
  )
}
export default HomePage
